import React from 'react';
import { observer } from 'mobx-react';

// Components
import InstructorHome from './InstructorHome';
import StudentHome from './StudentHome';

const Home = observer(
  class Home extends React.Component {
    constructor() {
      super();

      // Set the initial state
      this.state = {
        allCompleted: false,
        incomplete: []
      };
    }

    componentDidMount() {
      const { AssessmentStore, UserStore } = this.props.store;
      const { targetUserData, userData } = UserStore;
      const { role } = userData;
      const incomplete = [];

      // Callback to check if all assessments have been completed
      const callback = assessments => {
        let allCompleted = true;

        assessments.forEach(assessment => {
          if(!assessment.completedAttemptCount) {
            incomplete.push(assessment);
            allCompleted = false;
          }
        });

        this.setState({
          allCompleted,
          incomplete
        });
      };

      // Get all assessments for this assessment group
      let userSid = role.toLowerCase() === 'learner' ? userData.userSid : targetUserData.userSid;

      AssessmentStore.listGroupAssessments(
        UserStore.assessmentGroupSid,
        { userSid: userSid },
        callback
      );
    }

    render() {
      const { role } = this.props.store.UserStore.userData;

      if(role?.toLowerCase() === 'learner') {
        return (
          <StudentHome
            {...this.props}
            allCompleted={this.state.allCompleted}
          />
        )
      } else if(role.toLowerCase() === 'instructor') {
        return (
          <InstructorHome
            {...this.props}
            allCompleted={this.state.allCompleted}
            incomplete={this.state.incomplete}
          />
        )
      }

      return null;
    }
  }
);

export default Home;
